import React, { Fragment } from 'react';
import { Segment, Table, Checkbox, Button, Icon, Grid, Popup } from 'semantic-ui-react';
import moment from 'moment';
import axios from 'axios';
import SearchTableData from '../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

// since we dont need to have a way to display only selected, its sufficient to store the id-s only in selectedData
// props: data: [] selectedData: [] onDataChange (fn)

// names in event objects are stored as string while we need to compare them to integer ids
/* eslint-disable eqeqeq */

// data, selectedData, onDataChange (fn)
export default class DataTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            results: [],
            activeRole: localStorage.getItem('activeRole'),
        };

        this.onSelectRow = this.onSelectRow.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    onSelectRow(id) {
        let row = [];
        row = this.props.data.find(el => el.id == id);
        this.props.onDataChange(row);
    }

    getResults(results) {
        this.setState({ results });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.props.data;
    }

    render() {
        const { selectedData, data, studentService } = this.props;
        const dataTable =
            (<Fragment>
                {/* <Segment> */}
                {/*    <h3>Spisak studenata</h3> */}
                {/* </Segment> */}
                {/* <Segment clearing> */}
                <Table selectable celled>
                    <Table.Header>
                        <Table.HeaderCell colSpan={(this.state.activeRole === 'AIDA' || this.state.activeRole === 'Administrator') ? ((this.state.activeRole === 'AIDA' || this.state.activeRole === 'Administrator') && this.props.admin) ? 10 : 11 : 11}>
                            <SearchTableData profMozilla data={data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'indexNumber', 'documentNumber', 'studyProgramName', 'studyProgramBasicName', 'date', 'department']} />
                        </Table.HeaderCell>

                        <Table.Row>
                            { !this.props.admin && <Table.HeaderCell>
                                <Checkbox
                                    type="checkbox"
                                    name="checkAllButton"
                                    value={selectedData.length === data.length}
                                    onChange={this.props.selectAll}
                                    checked={selectedData.length === data.length}
                                />
                            </Table.HeaderCell>}
                            <Table.HeaderCell verticalAlign="middle" colSpan={2}>Prezime i ime studenta/ice</Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={1}>Broj diplome</Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={1}>Index</Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={2}>Odsjek</Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle"colSpan={2}>Studijski program</Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={2} width={3}>Datum diplomiranja</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body> {this.getDataToRender().map(row => (
                        <Table.Row onClick={() => this.onSelectRow(row.id)} key={row.id} className={selectedData.find(e => e.id === row.id) ? 'table-active' : ''}>
                            { !this.props.admin && <Table.Cell>
                                <Checkbox
                                    name={row.id}
                                    type="checkbox"
                                    checked={this.props.selectedData.findIndex(e => e.id === row.id) > -1}
                                />

                            </Table.Cell>}
                            <Table.Cell verticalAlign="middle" colSpan={2}>{row.lastName} {row.firstName} {row.locked ? <span style={{ float: 'right' }}> <Icon name="lock" color="blue" /></span> : null}</Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={1}>{row.documentNumber}</Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={1}>{row.indexNumber}</Table.Cell>
                            <Table.Cell verticalAlign="middle"colSpan={2}>{row.departmentsSPOU.map(e => <div>{e.organizationalUnitName} <br /></div>)}</Table.Cell>
                            <Table.Cell verticalAlign="middle"colSpan={2}><strong>{row.studyProgramBasicName}</strong> | {row.studyProgramName}</Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={2} width={3}>{row.dateOfGraduation === null ? null : moment(row.dateOfGraduation).format('D. M. YYYY.')}</Table.Cell>
                        </Table.Row>))}
                    </Table.Body>
                </Table>

                {!this.props.admin && <div style={{ float: 'right' }}>
                    Označeno <b>{selectedData.length}</b> od <b>{data.length}</b>.
                </div>}
                <br /><br />
                {studentService ?
                    <Button
                        floated="right"
                        icon
                        labelPosition="left"
                        color="blue"
                        onClick={() => this.props.printCertificates()}
                    >
                        <Icon className="print" />
                        Štampanje
                    </Button>
                    : <Fragment>
                        <Button
                            floated="left"
                            color="blue"
                            basic="true"
                            onClick={() => this.props.changeWizardStep('prev')}
                        >Nazad </Button>
                        {!this.props.admin && <Button
                            floated="right"
                            icon
                            labelPosition="left"
                            color="blue"
                            onClick={() => this.props.changeWizardStep('next')}
                        >
                            <Icon className="print" />
                            Štampanje
                        </Button>}
                    </Fragment>
                }
            </Fragment>);

        return (

            <div>
                {dataTable}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DegreeDocumentPrint/DataTable.js